import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { authApi } from '../services/api.js';

const TOKEN_KEY = 'admin_token';
const USER_KEY = 'admin_user';

export const useAuth = () => {
  const navigate = useNavigate();
  const [authState, setAuthState] = useState(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    const user = localStorage.getItem(USER_KEY);
    return {
      user: user ? JSON.parse(user) : null,
      token: token,
      isAuthenticated: !!token,
    };
  });

  const login = useCallback((userData, authToken) => {
    localStorage.setItem(TOKEN_KEY, authToken);
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
    setAuthState({
      user: userData,
      token: authToken,
      isAuthenticated: true,
    });
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    setAuthState({
      user: null,
      token: null,
      isAuthenticated: false,
    });
    navigate('/login');
  }, [navigate]);

  const handleLoginSubmit = useCallback(async (username, password) => {
    try {
      const res = await authApi.login({ username, password });
      if (res.success) {
        login(res.user, res.token);
        message.success('登录成功');
        setTimeout(() => {
          navigate('/dashboard', { replace: true });
        }, 100);
        return true;
      } else {
        message.error(res.message || '登录失败');
        return false;
      }
    } catch (error) {
      // 处理 401 错误 - 用户名或密码错误
      if (error.response?.status === 401) {
        const errorMsg = error.response.data?.message || '用户名或密码错误';
        message.error(errorMsg);
      } else if (error.response) {
        // 其他 HTTP 错误已由 api 拦截器处理
        console.error('登录请求失败:', error);
      } else {
        // 真正的网络错误（无响应）
        message.error('网络错误，请检查网络连接');
      }
      return false;
    }
  }, [login, navigate]);

  return {
    ...authState,
    login,
    logout,
    handleLoginSubmit,
  };
};

export default useAuth;
